import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import { ConstantsProvider } from '../context/ConstantsContext';
import { StoreProvider } from '../context/StoreContext';
import { SocketProvider } from '../context/SocketContext';
import ProtectedRoute from '../components/common/ProtectedRoute';
import StoreSelector from '../components/common/StoreSelector';
import HandheldLayout from './HandheldLayout';

import LoginPage from '../pages/LoginPage';
import HandheldDashboard from './pages/HandheldDashboard';
import HandheldLookupPage from './pages/HandheldLookupPage';
import HandheldCycleCountPage from './pages/HandheldCycleCountPage';
import HandheldReceivingPage from './pages/HandheldReceivingPage';
import HandheldTransfersPage from './pages/HandheldTransfersPage';
import HandheldLabelsPage from './pages/HandheldLabelsPage';
import HandheldSettingsPage from './pages/HandheldSettingsPage';

const HandheldApp = () => (
  <AuthProvider>
    <ConstantsProvider>
      <StoreProvider>
        <SocketProvider>
          <Router>
            <StoreSelector />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                element={
                  <ProtectedRoute>
                    <HandheldLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<HandheldDashboard />} />
                <Route path="/" element={<HandheldDashboard />} />
                <Route path="/lookup" element={<HandheldLookupPage />} />
                <Route path="/cycle-count" element={<HandheldCycleCountPage />} />
                <Route path="/receiving" element={<HandheldReceivingPage />} />
                <Route path="/transfers" element={<HandheldTransfersPage />} />
                <Route path="/labels" element={<HandheldLabelsPage />} />
                <Route path="/settings" element={<HandheldSettingsPage />} />
              </Route>
            </Routes>
          </Router>
        </SocketProvider>
      </StoreProvider>
    </ConstantsProvider>
  </AuthProvider>
);

export default HandheldApp;
